var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"path":_vm.path}}),_c('router-view',{staticClass:"body-top",attrs:{"path":_vm.path}}),_c('ToTopButton',{attrs:{"path":_vm.path}}),_c('Footer',{attrs:{"path":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }